import { brandsToOptions } from './formatters'

export const brandListSelector = (state) => state.brands.list
export const brandsOptionsSelector = (state) =>
  brandsToOptions(brandListSelector(state))
export const brandExpiresAtSelector = (state) => state.brands.expiresAt
